import { EContainerType } from '@/editor/types/entity';
import Model3d from './model';
import { EEntityType } from '@/editor/types';
import { globalStores } from '@/editor/stores';

class WindowModel extends Model3d {
  constructor(id: string) {
    super(id);

    this.intersectModel.userData.type = EEntityType.DoorWindow;
    this.intersectModel.userData.containerType = EContainerType.entity;
    this.intersectModel.userData.entityId = this._id;

    globalStores.editorStateStore.sceneInfo.scene3d.scene.add(this.model);
    globalStores.editorStateStore.sceneInfo.scene3d.intersectableGroup.add(this.intersectModel);
  }

  override setVisible(visible: boolean) {
    super.setVisible(visible);
    this.intersectModel.visible = visible;
  }
}

export default WindowModel;
